module.exports = __webpack_public_path__ + "img/BE0456775869.73c8e027.png";